import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useParams } from 'react-router-dom';
import SubHeader from '../components/common/SubHeader';
import { URL_AX_DB, URL_WOOD_EXPORT, URL_WORKFLOW } from '../constance/urls';
import { GET, PATCH, POST } from '../utils/HttpClient';
import * as _ from 'lodash';
import useDropdownItem from '../hooks/useDropdownItem';
import ExportItemList from '../components/wood-export/ExportItemList';
import { defaultExportTransactionDetail } from '../constance/dataTypes';
import { Toast } from '../utils/Toast';
import { PATH } from '../routes/Routes';
import ConfirmModal from '../components/common/ConfirmModal';
import { Divider, Alert, Card, Spin, Form, Input, Select, Button, Space, Layout, Row, Col } from 'antd';
import Title from 'antd/es/typography/Title';
import { ExportOutlined, SaveFilled } from '@ant-design/icons'
import { Content } from 'antd/es/layout/layout';
import ColorButton from '../components/common/ColorButton';
import { BLUE_COLOR } from '../constance/color';
import { useWindowDimensionContext } from '../hooks/WindowDimensionProvider';

export default function ExportTransactionDetailView(props) {
  const params = useParams();
  const history = useHistory();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = React.useState(false);
  const [errorMessages, setErrorMessages] = React.useState(null);
  const [isInterfaceConFirmModalOpen, setIsInterfaceConFirmModalOpen] = React.useState(false);
  const [form] = Form.useForm();
  const sale_order_no = Form.useWatch('sale_order_no', form)
  const container_no = Form.useWatch('container_no', form)
  const { size } = useWindowDimensionContext();

  const containerWidth = {
    xs: '100%',
    sm: 723,
    md: 933,
    lg: 1127,
    xl: 1127,
    xxl: 1127,
  }

  const onSubmit = async () => {
    setIsLoading(true);
    setErrorMessages(null);
    try {
      const value = await form.validateFields();
      await PATCH(`${URL_WOOD_EXPORT.EXPORT_TRANSACTION}${params.id}/`, value)
      Toast.success(t('success'))
      fetchData();
    } catch (error) {
      setErrorMessages(error.errorMessages)
    } finally {
      setIsLoading(false);
    }
  }

  const exportDocLineNoChoices = useDropdownItem({
    url: `${URL_AX_DB.AX_EXPORT_DOC}${sale_order_no}/${container_no}/`,
    manual: true,
    id: 'LINENUM',
    value: 'LINENUM',
    text_renderer: (item) => {
      const lineNum = _.get(item, 'LINENUM', '')
      const customerName = _.get(item, 'ECL_DRIVERNAME', '')
      const licensePlate = _.get(item, 'ECL_CARNUMBER', '')
      let stringRender = lineNum;
      stringRender += customerName ? ` : ${customerName}` : ''
      stringRender += licensePlate ? ` [${licensePlate}]` : ''
      return stringRender
    }
  })

  const fetchData = async () => {
    setIsLoading(true);
    setErrorMessages(null);
    try {
      const response = await GET(`${URL_WOOD_EXPORT.EXPORT_TRANSACTION}${params.id}`)
      form.setFieldsValue({
        ...defaultExportTransactionDetail,
        ...response.data,
        created: new Date(response.data.created).toLocaleString('en-GB') || '-',
        sale_order_no: response.data.sale_order_no || '-',
        container_no: response.data.container_no || '-',
        customer_code: response.data.customer_code || '-',
        export_doc: response.data.export_doc || '-',
        export_doc_line_no: response.data.export_doc_line_no || '-',
      })
    } catch (error) {
      setErrorMessages(error.errorMessages)
    } finally {
      setIsLoading(false);
    }
  }

  const handleDoInterfaceAX = async () => {
    try {
      const formValidation = await form.validateFields();
      setIsLoading(true);
      setErrorMessages(null);
      await PATCH(`${URL_WOOD_EXPORT.EXPORT_TRANSACTION}${params.id}/`, formValidation)
      await POST(`${URL_WOOD_EXPORT.EXPORT_TRANSACTION}${params.id}${URL_WOOD_EXPORT.INTERFACE}`)
      history.replace(PATH.EXPORT_TRANSACTION)

    } catch (error) {
      setErrorMessages(error.errorMessages)
    } finally {
      setIsLoading(false)
    }
  }

  React.useEffect(() => {
    if (params.id) {
      fetchData();
    }
  }, [params.id])

  React.useEffect(() => {
    if (sale_order_no && container_no) {
      exportDocLineNoChoices.fetchData();
    }
  }, [sale_order_no, container_no])

  const editable = !form.getFieldValue('is_completed') && !form.getFieldValue('is_interfaced');

  return (

    <Layout>
      <SubHeader />
      <div style={{ width: containerWidth[size], margin: "auto", marginTop: "1rem", textAlign: "left" }}>
        {errorMessages &&
          <Alert
            type="error"
            message={t('error')}
            description={errorMessages} />
        }

        <Title level={2} >{t('export_transactions.detail')}</Title>
        <Divider />
        <Card>
          <Spin spinning={isLoading} fullscreen size='large' />
          <Form form={form} initialValues={defaultExportTransactionDetail} layout='vertical'>

            <Row gutter={[16, 16]}>
              <Form.Item name={'is_completed'} hidden />
              <Form.Item name={'is_interfaced'} hidden />
              <Col sm={24} md={24} lg={6} style={{ width: '100%' }} >
                <Form.Item label={t('date')} name={'created'} >
                  <Input readOnly variant='borderless' />
                </Form.Item>
              </Col>
              <Col sm={24} md={24} lg={6} style={{ width: '100%' }} >
                <Form.Item
                  label={t('export_transactions.sale_order_no')} name={'sale_order_no'}>
                  <Input readOnly variant='borderless' />
                </Form.Item>
              </Col>
              <Col sm={24} md={24} lg={6} style={{ width: '100%' }} >
                <Form.Item
                  label={t('export_transactions.container_no')} name={'container_no'}>
                  <Input readOnly variant='borderless' />
                </Form.Item>
              </Col>
              <Col sm={24} md={24} lg={6} style={{ width: '100%' }} >
                <Form.Item
                  label={t('export_transactions.customer_code')} name={'customer_code'}>
                  <Input readOnly variant='borderless' />
                </Form.Item>
              </Col>
            </Row>
            <br />

            <Row gutter={[16, 16]}>
              <Col sm={24} md={24} lg={6} style={{ width: '100%' }} >
                <Form.Item
                  label={t('export_transactions.export_doc')} name={'export_doc'}>
                  <Input readOnly variant='borderless' />
                </Form.Item>
              </Col>
              <Col sm={24} md={24} lg={6} style={{ width: '100%' }} >
                <Form.Item
                  label={t('export_transactions.export_doc_line_no')} name={'export_doc_line_no'}>
                  <Select
                    showSearch
                    options={exportDocLineNoChoices.response}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>

          {editable &&
            <div style={{ textAlign: 'right', marginTop: '24px' }}>
              <Row gutter={[16, 16]} justify={'end'} >
                <Col sm={24} md={24} lg={5} style={{ width: '100%' }} >
                  {editable && (
                    <ColorButton
                      variant='outlined'
                      color='primary'
                      override={BLUE_COLOR}
                      icon={<ExportOutlined />}
                      onClick={() => setIsInterfaceConFirmModalOpen(true)}
                      block >
                      {t('menus.interface_ax')}
                    </ColorButton>
                  )}
                </Col>
                <Col sm={24} md={24} lg={5} style={{ width: '100%' }} >
                  <ColorButton
                    type='primary'
                    override={BLUE_COLOR}
                    icon={<SaveFilled />}
                    onClick={onSubmit}
                    block >
                    {t('save')}
                  </ColorButton>
                </Col>
              </Row>
            </div>
          }
          <Divider />

          <ExportItemList
            editable={editable}
            exportTransactionId={params.id} />
        </Card>
      </div>

      <ConfirmModal
        open={isInterfaceConFirmModalOpen}
        onClose={() => setIsInterfaceConFirmModalOpen(false)}
        title={t('confirms.interface_title')}
        content={t('confirms.interface_content')}
        onConfirm={() => handleDoInterfaceAX()}
      />
    </Layout>

  )
}
